module.exports = __webpack_public_path__ + "static/img/A2E_Cameroon_mobiya_2017SSD.2e21a54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/A2E_Cameroon_mobiya_2017SSD.jpg
// module id = eYuG
// module chunks = 0